import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'novus-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.css']
})
export class AboutComponent {

  constructor() { }

}
